<div class="paginator">
    <button id="prev" (click)="jumpToPage(activePage - 1)" [disabled]="activePage === 0" mat-flat-button disableRipple>
        <span class="material-icons">chevron_left</span>
    </button>

    <ul class="pages">
        <ng-container *ngFor="let item of displayPages">
            <li *ngIf="item.type === 'page'" class="page-btn">
                <a mat-flat-button disableRipple [class.active]="item.index === activePage"
                    (click)="jumpToPage(item.index)">
                    {{ item.label }}
                </a>
            </li>

            <li *ngIf="item.type === 'ellipsis'" class="ellipsis">…</li>
        </ng-container>
    </ul>

    <button id="next" (click)="jumpToPage(activePage + 1)" [disabled]="activePage === pages?.length - 1" mat-flat-button
        disableRipple>
        <span class="material-icons">chevron_right</span>
    </button>
</div>